import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';
import AdminLayout from '../core/layout/AdminLayout';
import { ProtectedRoute, PublicOnlyRoute } from '../core/guards/ProtectedRoute';
import { useAuth } from '../core/auth/AuthContext';
import { getFirstAccessiblePath } from '../core/utils/routeAccess';
import { authRoutes } from '../modules/auth';
import UnauthorizedPage from './pages/UnauthorizedPage';
import { allRoutes } from './routeConfig';

export { allRoutes } from './routeConfig';

const protectedRoutes = allRoutes.filter((r) => !r.public && r.element);

function PageLoader() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
      <Spin size="large" />
    </div>
  );
}

function DefaultRedirect() {
  const { user } = useAuth();
  const path = getFirstAccessiblePath(user, allRoutes) ?? '/unauthorized';
  return <Navigate to={path} replace />;
}

export default function AppRouter() {
  return (
    <Routes>
      {authRoutes.map((route) => {
        const Page = route.element;
        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              <PublicOnlyRoute>
                <Suspense fallback={<PageLoader />}>
                  <Page />
                </Suspense>
              </PublicOnlyRoute>
            }
          />
        );
      })}

      <Route
        path="/unauthorized"
        element={
          <ProtectedRoute>
            <UnauthorizedPage />
          </ProtectedRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute>
            <AdminLayout routes={allRoutes} />
          </ProtectedRoute>
        }
      >
        {protectedRoutes.map((route) => {
          const Page = route.element;
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedRoute permission={route.permission}>
                  <Suspense fallback={<PageLoader />}>
                    <Page />
                  </Suspense>
                </ProtectedRoute>
              }
            />
          );
        })}
      </Route>

      <Route path="*" element={<DefaultRedirect />} />
    </Routes>
  );
}
